import { render, staticRenderFns } from "./lessonRecommendRecord.vue?vue&type=template&id=7975c25e&scoped=true&"
import script from "./lessonRecommendRecord.vue?vue&type=script&lang=js&"
export * from "./lessonRecommendRecord.vue?vue&type=script&lang=js&"
import style0 from "./lessonRecommendRecord.vue?vue&type=style&index=0&id=7975c25e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7975c25e",
  null
  
)

export default component.exports